/* ════════════════════════════════════════════════════════════════════════
   DOCUMENTS DATA — categories, statuses, and seed entries for the
   household Documents & Admin Vault.
   ════════════════════════════════════════════════════════════════════════ */

export const DOCUMENT_CATEGORIES = [
  { id: "Bills",      label: "Bills",       emoji: "💸", tile: "bg-rose-50 dark:bg-rose-900/15 border-rose-200 dark:border-rose-800/60", dot: "bg-rose-500", text: "text-rose-700 dark:text-rose-300", icon: "Receipt" },
  { id: "Receipts",   label: "Receipts",    emoji: "🧾", tile: "bg-orange-50 dark:bg-orange-900/15 border-orange-200 dark:border-orange-800/60", dot: "bg-orange-500", text: "text-orange-700 dark:text-orange-300", icon: "Receipt" },
  { id: "School",     label: "School",      emoji: "🎒", tile: "bg-indigo-50 dark:bg-indigo-900/15 border-indigo-200 dark:border-indigo-800/60", dot: "bg-indigo-500", text: "text-indigo-700 dark:text-indigo-300", icon: "GraduationCap" },
  { id: "Medical",    label: "Medical",     emoji: "❤️", tile: "bg-pink-50 dark:bg-pink-900/15 border-pink-200 dark:border-pink-800/60", dot: "bg-pink-500", text: "text-pink-700 dark:text-pink-300", icon: "HeartPulse" },
  { id: "Insurance",  label: "Insurance",   emoji: "🛡️", tile: "bg-blue-50 dark:bg-blue-900/15 border-blue-200 dark:border-blue-800/60", dot: "bg-blue-500", text: "text-blue-700 dark:text-blue-300", icon: "Shield" },
  { id: "IDs",        label: "IDs",         emoji: "🪪", tile: "bg-violet-50 dark:bg-violet-900/15 border-violet-200 dark:border-violet-800/60", dot: "bg-violet-500", text: "text-violet-700 dark:text-violet-300", icon: "CreditCard" },
  { id: "House",      label: "House",       emoji: "🏠", tile: "bg-emerald-50 dark:bg-emerald-900/15 border-emerald-200 dark:border-emerald-800/60", dot: "bg-emerald-500", text: "text-emerald-700 dark:text-emerald-300", icon: "Home" },
  { id: "Vehicle",    label: "Vehicle",     emoji: "🚗", tile: "bg-cyan-50 dark:bg-cyan-900/15 border-cyan-200 dark:border-cyan-800/60", dot: "bg-cyan-500", text: "text-cyan-700 dark:text-cyan-300", icon: "Car" },
  { id: "Tax",        label: "Tax",         emoji: "📑", tile: "bg-amber-50 dark:bg-amber-900/15 border-amber-200 dark:border-amber-800/60", dot: "bg-amber-500", text: "text-amber-700 dark:text-amber-300", icon: "FileText" },
  { id: "Recipes",    label: "Recipes/Food", emoji: "🍳", tile: "bg-yellow-50 dark:bg-yellow-900/15 border-yellow-200 dark:border-yellow-800/60", dot: "bg-yellow-500", text: "text-yellow-700 dark:text-yellow-300", icon: "Utensils" },
  { id: "Other",      label: "Other",       emoji: "📦", tile: "bg-slate-50 dark:bg-slate-800/60 border-slate-200 dark:border-slate-700", dot: "bg-slate-500", text: "text-slate-700 dark:text-slate-300", icon: "FileText" },
];

export const DOCUMENT_CATEGORY_IDS = DOCUMENT_CATEGORIES.map(c => c.id);

export const DOCUMENT_STATUSES = ["Inbox", "Filed", "Needs action", "Reminder set", "Archived"];

export const DOCUMENT_STATUS_STYLE = {
  "Inbox":         { chip: "bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-300",       dot: "bg-sky-500" },
  "Filed":         { chip: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300", dot: "bg-emerald-500" },
  "Needs action":  { chip: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300", dot: "bg-amber-500" },
  "Reminder set":  { chip: "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300", dot: "bg-violet-500" },
  "Archived":      { chip: "bg-slate-200 text-slate-600 dark:bg-slate-700 dark:text-slate-300",  dot: "bg-slate-400" },
};

/* Map Home OS module → default document category, used when filing a
   quick-capture into the vault. */
export const MODULE_TO_DOC_CATEGORY = {
  documents: "Other",
  money:     "Bills",
  health:    "Medical",
  family:    "School",
  meals:     "Recipes",
  supplies:  "Receipts",
  calendar:  "Other",
  chores:    "Other",
};

const NOW_ISO = new Date().toISOString();
const isoOffset = (d) => {
  const t = new Date();
  t.setDate(t.getDate() + d);
  return t.toISOString().slice(0, 10);
};

export const SEED_DOCUMENTS = [
  {
    id: "doc-1",
    title: "Power bill — March",
    category: "Bills",
    type: "bill",
    source: "Manual Entry",
    fileName: "",
    fileType: "",
    attachmentData: null,
    thumbnailData: null,
    linkedCaptureId: null,
    linkedTaskId: null,
    assignedTo: "dad",
    relatedPerson: null,
    dueDate: isoOffset(3),
    renewalDate: null,
    reminderDate: isoOffset(2),
    status: "Needs action",
    notes: "Auto-pay set up but always double-check the amount.",
    tags: ["utility", "monthly"],
    createdAt: NOW_ISO, updatedAt: NOW_ISO,
  },
  {
    id: "doc-2",
    title: "Lily — school trip permission slip",
    category: "School",
    type: "form",
    source: "Manual Entry",
    fileName: "",
    fileType: "",
    attachmentData: null,
    thumbnailData: null,
    linkedCaptureId: null,
    linkedTaskId: null,
    assignedTo: "mum",
    relatedPerson: "child",
    dueDate: isoOffset(4),
    renewalDate: null,
    reminderDate: isoOffset(2),
    status: "Needs action",
    notes: "Zoo trip — needs signature + $12 cash.",
    tags: ["school", "permission"],
    createdAt: NOW_ISO, updatedAt: NOW_ISO,
  },
  {
    id: "doc-3",
    title: "Car WOF — due next week",
    category: "Vehicle",
    type: "renewal",
    source: "Manual Entry",
    fileName: "",
    fileType: "",
    attachmentData: null,
    thumbnailData: null,
    linkedCaptureId: null,
    linkedTaskId: null,
    assignedTo: "dad",
    relatedPerson: null,
    dueDate: isoOffset(7),
    renewalDate: isoOffset(7),
    reminderDate: isoOffset(5),
    status: "Reminder set",
    notes: "Book at VTNZ Mt Eden.",
    tags: ["car", "wof", "renewal"],
    createdAt: NOW_ISO, updatedAt: NOW_ISO,
  },
  {
    id: "doc-4",
    title: "Home & contents insurance policy",
    category: "Insurance",
    type: "policy",
    source: "Manual Upload",
    fileName: "home_contents_policy_2026.pdf",
    fileType: "application/pdf",
    attachmentData: null,
    thumbnailData: null,
    linkedCaptureId: null,
    linkedTaskId: null,
    assignedTo: "mum",
    relatedPerson: null,
    dueDate: null,
    renewalDate: isoOffset(90),
    reminderDate: isoOffset(75),
    status: "Filed",
    notes: "Annual renewal — review excess before renewing.",
    tags: ["insurance", "annual"],
    createdAt: NOW_ISO, updatedAt: NOW_ISO,
  },
  {
    id: "doc-5",
    title: "Max — allergy plan",
    category: "Medical",
    type: "medical-plan",
    source: "Manual Upload",
    fileName: "max_allergy_plan.pdf",
    fileType: "application/pdf",
    attachmentData: null,
    thumbnailData: null,
    linkedCaptureId: null,
    linkedTaskId: null,
    assignedTo: "mum",
    relatedPerson: "child",
    dueDate: null,
    renewalDate: isoOffset(180),
    reminderDate: null,
    status: "Filed",
    notes: "Copy at school + at home. Update each year.",
    tags: ["medical", "allergy", "max"],
    createdAt: NOW_ISO, updatedAt: NOW_ISO,
  },
  {
    id: "doc-6",
    title: "Laptop receipt (Jan 2026)",
    category: "Receipts",
    type: "receipt",
    source: "Manual Upload",
    fileName: "laptop_receipt_jan2026.jpg",
    fileType: "image/jpeg",
    attachmentData: null,
    thumbnailData: null,
    linkedCaptureId: null,
    linkedTaskId: null,
    assignedTo: "dad",
    relatedPerson: null,
    dueDate: null,
    renewalDate: null,
    reminderDate: null,
    status: "Filed",
    notes: "2-year warranty.",
    tags: ["receipt", "warranty"],
    createdAt: NOW_ISO, updatedAt: NOW_ISO,
  },
  {
    id: "doc-7",
    title: "Lily — passport expiry",
    category: "IDs",
    type: "id",
    source: "Manual Entry",
    fileName: "",
    fileType: "",
    attachmentData: null,
    thumbnailData: null,
    linkedCaptureId: null,
    linkedTaskId: null,
    assignedTo: "mum",
    relatedPerson: "child",
    dueDate: null,
    renewalDate: isoOffset(45),
    reminderDate: isoOffset(30),
    status: "Reminder set",
    notes: "Renewal takes ~6 weeks — start early.",
    tags: ["passport", "id", "renewal"],
    createdAt: NOW_ISO, updatedAt: NOW_ISO,
  },
  {
    id: "doc-8",
    title: "Streaming subscription renewal",
    category: "Bills",
    type: "subscription",
    source: "Manual Entry",
    fileName: "",
    fileType: "",
    attachmentData: null,
    thumbnailData: null,
    linkedCaptureId: null,
    linkedTaskId: null,
    assignedTo: "dad",
    relatedPerson: null,
    dueDate: null,
    renewalDate: isoOffset(20),
    reminderDate: isoOffset(14),
    status: "Reminder set",
    notes: "Decide whether to renew or downgrade.",
    tags: ["subscription", "monthly"],
    createdAt: NOW_ISO, updatedAt: NOW_ISO,
  },
];
